import React, { PureComponent } from 'react';
import ActionButton from '../common/Button/ActionButton';
import PropTypes from 'prop-types';

const NoMatchStyle = {
  root: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 9999,
    backgroundColor: '#FFFFFF',
  },
  error: {
    fontSize: 180,
    textAlign: 'center',
  },
};

class NoMatch extends PureComponent {
  goBack = () => {
    const { history } = this.props;
    history && history.goBack();
  };

  render() {
    return (
      <div
        style={NoMatchStyle.root}
        className="d-flex flex-column align-content-center justify-content-center text-center pb-md-5"
      >
        <div className="pb-5">
          <h1 style={NoMatchStyle.error}>404</h1>
          <h3 className="d-none d-sm-block">SO SORRY, PAGE NOT FOUND</h3>
          <div className="d-sm-none">
            <h3>SO SORRY</h3>
            <h3>PAGE NOT FOUND</h3>
          </div>
          <ActionButton type="primary" onClick={this.goBack}>
            Go back
          </ActionButton>
        </div>
      </div>
    );
  }
}

NoMatch.propTypes = {
  history: PropTypes.object.isRequired,
};

export default NoMatch;
